// extracted by mini-css-extract-plugin
module.exports = {"swapEntities":"SwapWorkAssignmentModal_swapEntities__1-JbA","icon":"SwapWorkAssignmentModal_icon__3Zo1-"};